export const locale = {
    lang: "en",
    data: {
      "BUTTONS": {
        
      },
      "FIELDS": {
        'Status': 'Status',
        'Not-Found-Status': 'Status not found',
      },
    }
  };
  